/* visitorMapsUrl — Google Maps deep-link for a ring's visitor position.
   Prefers the raw GPS pin (precise) over a text search of the
   reverse-geocoded / IP-derived location label. Returns null when the
   ring has no location signal at all. */
export function visitorMapsUrl(ring) {
  if (ring?.visitor_latitude != null && ring?.visitor_longitude != null) {
    return `https://www.google.com/maps/search/?api=1&query=${ring.visitor_latitude},${ring.visitor_longitude}`;
  }
  if (ring?.visitor_location) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ring.visitor_location)}`;
  }
  return null;
}
